import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {IDocument} from "../../interfaces/document.definition";
import {Subject} from "rxjs/Subject";
import {WatchService} from "../../services/watch.service";
import {CollectionService} from "../../services/collection.service";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {DOCUMENT_TYPES} from "../../enums/enums";

@Component({
  selector: 'nv-tags',
  templateUrl: './nv-tags.component.html',
  styles: []
})
export class NvTagsComponent implements OnInit, OnDestroy {

  @Input() document:IDocument;
  @Input() propertyName:string;

  loadedTagsList:IDocument[]=[];
  currentTag:string;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private collectionService:CollectionService,
              private watchService:WatchService) { }

  ngOnInit(){
    this.loadTagsList();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onAddClick(){
    this.document[this.propertyName].push(this.currentTag);
    this.watchService.notify();
  }

  getTagLabel(t){
    return t;
  }

  private loadTagsList(){
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setSearchParams(paramsHelper.search()
        .addParam("_type", SEARCH_PROP_TYPES.STRING,
          DOCUMENT_TYPES.GO_TAG).json
      )
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .takeUntil(this.unsubscribe)
      .subscribe(r => {
        this.loadedTagsList = r.documents;
        this.loadedTagsList.sort(this.sortByName);
        if (this.loadedTagsList.length > 0)
        {
          this.currentTag = this.loadedTagsList[0].name;
        }
      });
  }

  private sortByName(a, b):number
  {
    if (a.name > b.name)
    {
      return 1;
    }
    else if (a.name < b.name)
    {
      return -1;
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-tags/nv-tags.component.ts